/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]:before{background:url(homepage-peb-chauffage.c4e67f663b09550fdf3f.svg) center no-repeat}"];
export { styles as styles };
